// Dynamic manifest generator based on PWA configuration
export const generateManifest = (isPWAEnabled = false) => {
  // Get the current origin to create absolute URLs
  const origin = window.location.origin;
  
  const baseManifest = {
    "short_name": "ECI Time Portal",
    "name": "ECI Timesheet Application",
    "description": "ECI employee timesheet tracking and management application",
    "icons": [
      {
        "src": `${origin}/favicon.ico`,
        "sizes": "64x64 32x32 24x24 16x16",
        "type": "image/x-icon"
      },
      {
        "src": `${origin}/timesheet_logo192.png`,
        "type": "image/png",
        "sizes": "192x192",
        "purpose": "any"
      },
      {
        "src": `${origin}/timesheet_logo512.png`,
        "type": "image/png",
        "sizes": "512x512",
        "purpose": "any"
      },
      {
        "src": `${origin}/timesheet_logo192_mask.png`,
        "type": "image/png",
        "sizes": "192x192",
        "purpose": "maskable"
      },
      {
        "src": `${origin}/timesheet_logo512_mask.png`,
        "type": "image/png",
        "sizes": "512x512",
        "purpose": "maskable"
      }
    ],
    "start_url": `${origin}/`,
    "orientation": "portrait-primary",
    "theme_color": "#2196f3",
    "background_color": "#ffffff",
    "scope": `${origin}/`,
    "categories": ["business", "productivity"],
    "lang": "en-US",
    "dir": "ltr"
  };

  // Set display mode based on PWA configuration
  if (isPWAEnabled) {
    baseManifest.display = "standalone";
  } else {
    baseManifest.display = "browser";
  }

  return baseManifest;
};

// Update manifest link in document head
export const updateManifestLink = (isPWAEnabled = false) => {
  // Remove existing manifest link first
  const existingLink = document.querySelector('link[rel="manifest"]');
  if (existingLink) {
    existingLink.remove();
  }
  
  // If PWA is disabled, just use the static manifest
  if (!isPWAEnabled) {
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = '/manifest.json';
    document.head.appendChild(link);
    console.log('Manifest updated: using static manifest, PWA disabled');
    return '/manifest.json';
  }
  
  // For PWA enabled, create dynamic manifest with absolute URLs
  const manifest = generateManifest(isPWAEnabled);
  const manifestBlob = new Blob([JSON.stringify(manifest, null, 2)], {
    type: 'application/json'
  });
  const manifestURL = URL.createObjectURL(manifestBlob);
  
  // Add new manifest link
  const link = document.createElement('link');
  link.rel = 'manifest';
  link.href = manifestURL;
  document.head.appendChild(link);
  
  // Reduced logging for PWA manifest updates
  if (isPWAEnabled) {
    console.log(`Manifest updated: display mode = ${manifest.display}, PWA enabled = ${isPWAEnabled}`);
  }
  
  return manifestURL;
};
